import BaseAPIService from '@/services/baseAPIService'

export default class AccountsAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }
  
  getInvoice(id)                                { return this.httpClient.get(`/accounts/invoices/${id}`) }
  getInvoiceFilteredList(options = {}) {
    var params = {
      filter: options.filter || {},
      order: options.order || [],
      columns: options.columns || []
    }
    
    var queryString = '/accounts/invoices?' + $.param(params)

    return this.httpClient.get(queryString)
  }
  updateInvoice(id, data)                       { return this.httpClient.put(`/accounts/invoices/${id}`, data) }
  closeInvoice(id, data)                        { return this.httpClient.post(`/accounts/invoices/${id}/close`, data) }

  getInvoiceSendInvoiceTemplate(id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/accounts/invoices/${id}/msgtemplates/sendinvoice?${$.param(params)}`)
  }
  sendInvoiceEmail(id, data)                    { return this.httpClient.post(`/accounts/invoices/${id}/sendinvoice`, data) }

  createPaymentReceived(data)                   { return this.httpClient.post(`/accounts/paymentreceiveds`, data) }
  getPaymentReceived(id)                        { return this.httpClient.get(`/accounts/paymentreceiveds/${id}`) }
  updatePaymentReceived(id, data)               { return this.httpClient.put(`/accounts/paymentreceiveds/${id}`, data) }
  cancelPaymentReceived(id, data)               { return this.httpClient.post(`/accounts/paymentreceiveds/${id}/cancel`, data) }

  getPaymentReceivedSendReceiptTemplate(id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/accounts/paymentreceiveds/${id}/msgtemplates/sendreceipt?${$.param(params)}`)
  }
  sendPaymentReceivedEmail(id, data)            { return this.httpClient.post(`/accounts/paymentreceiveds/${id}/sendreceipt`, data) }

  createCreditNote(data)                        { return this.httpClient.post(`/accounts/creditnotes`, data) }
  getCreditNote(id)                             { return this.httpClient.get(`/accounts/creditnotes/${id}`) }
  getCreditNoteFilteredList(options = {}) {
    var params = {
      filter: options.filter || {},
      order: options.order || [],
      columns: options.columns || []
    }
    
    var queryString = '/accounts/creditnotes?' + $.param(params)

    return this.httpClient.get(queryString)
  }
  addCreditAllocations(id, data)                { return this.httpClient.post(`/accounts/creditnotes/${id}/allocate`, data) }
  cancelCreditNote(id, data)                    { return this.httpClient.post(`/accounts/creditnotes/${id}/cancel`, data) }
  closeCreditNote(id, data)                     { return this.httpClient.post(`/accounts/creditnotes/${id}/close`, data) }

  getCreditNoteSendReceiptTemplate(id, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/accounts/creditnotes/${id}/msgtemplates/sendreceipt?${$.param(params)}`)
  }
  sendCreditNoteEmail(id, data)            { return this.httpClient.post(`/accounts/creditnotes/${id}/sendreceipt`, data) }

  getOverPayment(id)                            { return this.httpClient.get(`/accounts/overpayments/${id}`) }
  addOverpaymentAllocations(id, data)           { return this.httpClient.post(`/accounts/overpayments/${id}/allocate`, data) }
  closeOverpayment(id, data)                    { return this.httpClient.post(`/accounts/overpayments/${id}/close`, data) }

  getSendContactListStatementTemplate(messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/accounts/reports/statements/template?${$.param(params)}`)
  }
  sendContactListStatements(data)                  { return this.httpClient.post(`/accounts/reports/statements/send`, data) }

  getContactStatementTemplate(contactId, messageTemplateId) {
    var params = { messageTemplateId: messageTemplateId }
    return this.httpClient.get(`/accounts/contacts/${contactId}/statements/template?${$.param(params)}`)
  }
  sendContactStatement(contactId, data)                  { return this.httpClient.post(`/accounts/contacts/${contactId}/statements/send`, data) }

  // Accounts - Config Settings
  getConfigSettings()               { return this.httpClient.get(`/accounts/configuration/settings`) }
  updateConfigSettings(data)        { return this.httpClient.put(`/accounts/configuration/settings`, data) }
}